export const FETCH_SPECIAL_PROMO_GIFT_START = 'FETCH_SPECIAL_PROMO_GIFT_START';
export const FETCH_SPECIAL_PROMO_GIFT_SUCCESS = 'FETCH_SPECIAL_PROMO_GIFT_SUCCESS';
export const FETCH_SPECIAL_PROMO_GIFT_FAILURE = 'FETCH_SPECIAL_PROMO_GIFT_FAILURE';
